import gql from 'graphql-tag';

const paginationFragment = gql`
  fragment paginationParts on Pagination {
    pageSize
    totalResults
    totalPages
    page
    previous
    next
    hasNext
  }
`;

const simplePaginationFragment = gql`
  fragment simplePaginationParts on SimplePagination {
    page
    pageSize
    hasNextPage
  }
`;

export default paginationFragment;

export { paginationFragment, simplePaginationFragment };
